module.exports = __webpack_public_path__ + "media/recipes/2-7bf7c912.png";